import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { sixthFlowsActions} from 'features/sixthFlows';

const useSixthFlows = () => {
  const dispatch = useDispatch();
  const getSixthFlow = useCallback(() => dispatch(sixthFlowsActions.getSixthFlow()), [dispatch]);
  const createSixthFlow = useCallback(sixth_flow => dispatch(sixthFlowsActions.createSixthFlow(sixth_flow)), [dispatch]);
  const updateSixthFlow = useCallback(sixth_flow => dispatch(sixthFlowsActions.updateSixthFlow(sixth_flow)), [dispatch]);
  const deleteSixthFlow = useCallback(() => dispatch(sixthFlowsActions.deleteSixthFlow()), [dispatch]);
  const clearLocalActiveSixthFlow = useCallback(() => dispatch(sixthFlowsActions.clearLocalActiveSixthFlow()), [dispatch]);

  return {
    getSixthFlow,
    createSixthFlow,
    updateSixthFlow,
    deleteSixthFlow,
    clearLocalActiveSixthFlow
  };
};

export default useSixthFlows;